import React, { lazy, Suspense } from 'react';

const LazyInStoreSignageOrderForm= lazy(() => import('./InStoreSignageOrderForm'));

const InStoreSignageOrderForm = (props: React.JSX.IntrinsicAttributes & { children?: React.ReactNode; }) => (
  <Suspense fallback={null}>
    <LazyInStoreSignageOrderForm {...props} />
  </Suspense>
);

export default InStoreSignageOrderForm;
